import React from 'react';
import './Tabs.scss';

export interface TabsProps {
  children: React.ReactNode;
  className?: string;
  'aria-label'?: string;
}

const Tabs: React.FC<TabsProps> = ({
  children,
  className = '',
  'aria-label': ariaLabel,
}) => {
  const baseClass = 'tabs';

  const classes = [
    baseClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      role="tablist"
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
};

export default Tabs;

